import React from 'react';
import { MainContainerItems, Subtitle, TimeDiv } from './ProcedureData.styled';
import {
    HeaderData,
    DemiText,
} from 'src/common/components/dataTable/DataTable.styled';
import { formatAMPM, getDisplayDate } from 'src/utils/dateUtils';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import { MobileView } from 'src/pages/orders/index';
import { useTranslation } from 'react-i18next';
import { getTimeZoneName } from 'src/utils/dateUtils';

const ProcedureDataMobileView = ({
    dataToBeMapped,
    toggleProcedureCard,
    ordersList,
}) => {
    const { t } = useTranslation();
    const isCondensedView = useSelector(
            (state) => state.loginReducer.isCondensedView
        );
    return (
        <MobileView>
            {dataToBeMapped ? (
                dataToBeMapped &&
                dataToBeMapped.length &&
                dataToBeMapped.map((proc, ind) => {
                    return (
                        <CollapsableCard
                            id={'orders-procedureDataMobileView-procedureDataMobileView-procedureDetails-submitted'}
                            key={ind}
                            title={`${t('orders.priceOverrideHistoryStatus.submitted')} ${getDisplayDate(
                                new Date(proc.creationDateTime)
                            )}`}
                            onClick={() => toggleProcedureCard(ind)}
                            isExpanded={proc.openCard}
                            padding={'1rem'}
                        >
                            {proc.openCard ? (
                                <>
                                    {proc?.creationDateTime ? (
                                        <MainContainerItems width={'100%'}>
                                            <div>
                                                <TimeDiv>
                                                    {formatAMPM(
                                                        proc.creationDateTime
                                                    )}{' '}
                                                    {`${getTimeZoneName()} ${t('orders.orderDetails.billingSummary.by')} `}
                                                    <span className="orders-procedure-created-by-dt-mask">{proc.createdBy}</span>
                                                </TimeDiv>
                                            </div>
                                        </MainContainerItems>
                                    ) : null}

                                    <MainContainerItems width={'100%'}>
                                        <HeaderData>
                                            <DemiText
                                                marginBottom={'0px'}
                                                mbFontSize={'14px'}
                                            >
                                                {t('scheduleSurgery.details.AccountPhysicianTemplate.Physician')}
                                            </DemiText>
                                        </HeaderData>
                                        <Subtitle className="orders-physician-dt-mask" fontSize={'14px'}>
                                            {proc?.physicianName
                                                ? proc.physicianName
                                                : 'NA'}
                                        </Subtitle>
                                    </MainContainerItems>
                                    <MainContainerItems width={'100%'}>
                                        <HeaderData>
                                            <DemiText
                                                marginBottom={'0px'}
                                                mbFontSize={'14px'}
                                            >
                                                {t('orders.orderDetails.procedureData.procedureDetails')}
                                            </DemiText>
                                        </HeaderData>
                                        <Subtitle fontSize={'14px'}>
                                            {proc?.procedureName}
                                        </Subtitle>
                                        {proc?.pediatricSurgery && (
                                <Subtitle fontSize={'14px'}>
                                    {t('common.pediatricProcedureLabel')}
                                </Subtitle>
                            )}
                                        {proc?.procedureDetails
                                            ? proc.procedureDetails?.map(
                                                  (x, index) => {
                                                      return (
                                                          <Subtitle
                                                              key={index}
                                                              fontSize={'14px'}
                                                          >
                                                              {x !==
                                                                  'PediatricSurgery' &&
                                                                  x}
                                                          </Subtitle>
                                                      );
                                                  }
                                              )
                                            : null}
                                    </MainContainerItems>

                                    <MainContainerItems width={'100%'}>
                                        <HeaderData>
                                            <DemiText
                                                marginBottom={'0px'}
                                                mbFontSize={'14px'}
                                            >
                                                {t('orders.orderDetails.procedureData.biologicsUsed')}
                                            </DemiText>
                                        </HeaderData>
                                        {proc?.biologicsDetails ? (
                                            proc.biologicsDetails?.map(
                                                (x, index) => {
                                                    return (
                                                        <Subtitle
                                                            fontSize={'14px'}
                                                            key={index}
                                                        >
                                                            {x}
                                                        </Subtitle>
                                                    );
                                                }
                                            )
                                        ) : (
                                            <Subtitle fontSize={'14px'}>
                                                {t('orders.orderDetails.procedureData.na')}
                                            </Subtitle>
                                        )}
                                    </MainContainerItems>
                                </>
                            ) : null}
                        </CollapsableCard>
                    );
                })
            ) : (
                <div style={{ marginLeft: isCondensedView ?  '15px' : '0px' }}>{t('orders.orderDetails.procedureData.nofound')}</div>
            )}
        </MobileView>
    );
};

export default ProcedureDataMobileView;
